import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en.json'
import zhTW from './locales/zh-TW.json'
import ja from './locales/ja.json'
import ko from './locales/ko.json'
import fr from './locales/fr.json'
import de from './locales/de.json'
import es from './locales/es.json'
import id from './locales/id.json'
import datetimeFormats from '@/i18n/datetimeFormats'
import numberFormats from '@/i18n/numberFormats'

Vue.use(VueI18n)

// 语言代码映射
export const LOCALE_MAP = {
  'en': 'en', // English
  'zh-TW': 'zh-hant', // 繁體中文
  'ja': 'ja', // 日本語
  'ko': 'ko', // 한국어
  'fr': 'fr', // Français
  'de': 'de', // Deutsch
  'es': 'es', // Español
  'id': 'id', // Bahasa Indonesia
} as const

export type LocaleCode = keyof typeof LOCALE_MAP

// 默认语言
export const DEFAULT_LOCALE: LocaleCode = 'en'

// 获取浏览器语言
function getBrowserLocale(): LocaleCode {
  const browserLang = navigator.language || (navigator as any).userLanguage

  // 匹配语言代码
  if (browserLang.startsWith('zh-TW') || browserLang.startsWith('zh-HK'))
    return 'zh-TW'

  if (browserLang.startsWith('ja'))
    return 'ja'

  if (browserLang.startsWith('ko'))
    return 'ko'

  if (browserLang.startsWith('fr'))
    return 'fr'

  if (browserLang.startsWith('de'))
    return 'de'

  if (browserLang.startsWith('id'))
    return 'id'

  if (browserLang.startsWith('es'))
    return 'es'

  return DEFAULT_LOCALE
}

// 从 localStorage 获取语言设置
function getStoredLocale(): LocaleCode | null {
  const stored = localStorage.getItem('locale')
  if (stored && stored in LOCALE_MAP)
    return stored as LocaleCode

  return null
}

// 初始化语言设置
const initialLocale = getStoredLocale() || getBrowserLocale()

// 创建 i18n 实例
export const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    en,
    'zh-TW': zhTW,
    ja,
    ko,
    fr,
    de,
    es,
    id,
  },
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  dateTimeFormats: datetimeFormats, // 日期格式化
  numberFormats, // 数字格式化
})

// 保存语言设置到 localStorage
export function setLocale(locale: LocaleCode) {
  localStorage.setItem('locale', locale)
  i18n.locale = locale
}

export default i18n
